import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
export default {
	init() {
    // Top Graphic
    let shapes = document.querySelector('.upper-graphic')
    gsap.to(shapes, { scale: 1, opacity: 1})
    // Left Graphic
    let lg = document.querySelector('.left-graph')
    if (lg) {
      let lgtl = gsap.timeline({
        scrollTrigger: {
          trigger: lg,
          start: 'top center',
        },
      })
      lgtl.to(lg, {opacity: 1, scale: 1, duration: 1, ease: 'power4.out'})
    }
  },
  finalize() {
  },
};
